// extracted by mini-css-extract-plugin
export default {"so-container":"SingleOrder_so-container__IbyU8","item-name":"SingleOrder_item-name__+vFDL"};